<!--
 * @Author: caoyingming 1046659469@qq.com
 * @Date: 2022-07-18 09:17:23
 * @LastEditors: caoyingming 1046659469@qq.com
 * @LastEditTime: 2022-08-23 14:02:46
 * @FilePath: /genetron-web/genetron-h5/src/views/reportQuery/variationDetails copy.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="reportIndex">
    <!-- <van-sticky>
      <div class="sticky">
        <div
          class="search"
          :style="{ paddingTop: $route.query.navHeight + 'px' }"
        >
          <div>
            <form action="/">
              <van-search
                v-model="searchValue"
                shape="round"
                background="none"
                placeholder="搜索基因/核苷酸/氨基酸"
                @search="onSearch"
                @clear="onClear"
              >
                <template #left-icon>
                  <i style="color: #a4a9bf" class="iconfont icon-search_s"></i>
                </template>
              </van-search>
            </form>
          </div>
        </div>
      </div>
    </van-sticky> -->

    <div class="content">
      <div class="pointMutation publicLess">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text=""
          @load="onLoad"
          class="van-load"
        >
          <div class="null-box" v-if="isEmpty">
            <van-empty
              class="custom-image"
              image-size="100px"
              :image="require('../../assets/not.png')"
              description="未检出"
            />
          </div>
          <div v-else>
            <van-loading class="show-loading" v-show="dataloading" />
            <div class="aaa">
              <div
                class="mutation-list publicLess-list"
                v-for="(item, index) in list"
                :key="index"
              >
                <h1 @click="geneClick(item)">{{ item.geneName }}</h1>
                <div class="show-box"></div>
                <div class="data-box">
                  <div class="left">
                    <div>
                      <p>核苷酸变化</p>
                      <h2>{{ item.cdnaChange }}</h2>
                    </div>
                    <div>
                      <p>变异类型/检测结果</p>
                      <h2>{{ item.variantClassificationChinese }}</h2>
                    </div>
                    <div>
                      <p>外显子</p>
                      <h2>{{ item.exon }}</h2>
                    </div>
                    <!-- <div>
                    <p>转录本</p>
                    <h2>{{ item.refseqMrnaId }}</h2>
                  </div> -->
                    <div>
                      <p>相同变异患者</p>
                      <h3 @click="byClick(item)">{{ item.cohort }}</h3>
                    </div>
                  </div>
                  <div class="right">
                    <div>
                      <p>氨基酸变化</p>
                      <h3 @click="wdClick(item)">
                        {{ item.proteinChangeShort }}
                      </h3>
                    </div>
                    <div>
                      <p>
                        {{ item.variantType === "cnv" ? "拷贝数" : "突变频率" }}
                      </p>
                      <h2 v-if="item.variantType === 'cnv'">
                        {{ item.vaf }}
                      </h2>
                      <h2 v-else>{{ item.vaf }}%</h2>
                    </div>
                    <div>
                      <p>转录本</p>
                      <h2>{{ item.refseqMrnaId }}</h2>
                    </div>
                    <!-- <div v-if="$route.query.userAgent != 'wxWeb'">
                    <p>相同变异患者</p>
                    <h3 @click="byClick(item)">{{ item.cohort }}</h3>
                  </div> -->
                    <!-- <div>
                <p>变异等级</p>
                <h2>{{ "" }}</h2>
              </div> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </van-list>
      </div>
    </div>
  </div>
</template>
<script>
import isiOS from "@/utils/iosAn";
import { mapMutations } from "vuex";
import { findKnowledgeNoBiomarkerMutation } from "@/api/reportQuery";
import { handleSearch } from "@/utils/search";
import { mapState } from "vuex";
export default {
  name: "reportIndex",
  data() {
    return {
      dataloading: true,
      isEmpty: false,
      loading: false,
      finished: false,
      mutationData: [],
      list: [],
      searchData: [],
      value: "",
      searchValue: "",
    };
  },
  watch: {
    searchVal: function (val) {
      if (!val) {
        this.clearSearch();
      }
    },
  },
  computed: {
    ...mapState("embry", ["publicParams"]),
  },
  mounted() {
    console.log(this.$route.query.navHeight, "222");
    let params = {
      labOriginalSampleNo: this.$route.query.fname,
      productId: this.$route.query.fid,
    };

    this.setPublic(params);
    this.getData();
    window.NativeCallJS = (res) => {
      console.log(res, "resresresresres");
      this.getData(res);
    };
  },
  methods: {
    ...mapMutations("embry", ["setPublic"]),
    getData(bully) {
      this.dataloading = true;
      findKnowledgeNoBiomarkerMutation({
        // labOriginalSampleNo: this.$route.query.fname,
        // productId: this.$route.query.fid,
        labOriginalSampleNo: "F22024225T",
        productId: "fwa-p825-glioma",
        bully: bully,
      }).then((res) => {
        this.dataloading = false;
        console.log(res);
        this.list = res.data;
        if (res.data.length === 0) {
          this.isEmpty = true;
        } else {
          this.isEmpty = false;
        }
      });
    },
    callback(type) {
      if (isiOS) {
        window.webkit.messageHandlers.JSCallNative.postMessage({ type: type });
      } else {
        window.android.JSCallNative(JSON.stringify({ type: type, name: "" }));
      }
    },

    hanldTab(val) {
      console.log(val);
      this.value = "";
    },
    onSearch(val) {
      this.searchValue = val;
      this.getData();
      console.log(val);
      // this.searchFn();
    },
    onClear() {
      this.getData();
      // this.clearSearch();
    },
    // 氨基酸位点点击事件
    wdClick(item) {
      let param = {
        name: "wdJiedu",
        type: "1",
        gene: item.geneName,
        proteinChange: "-" + item.proteinChange,
        tabIndex: "2",
        fromSource: "snv",
        cancerTwo: item.cancerTwo,
        productCode: item.productCode,
      };
      if (this.$route.query.userAgent == "wxWeb") {
        wx.miniProgram.navigateTo({
          url:
            "/packageWebView/pages/site-jiedu/site-jiedu?site=" +
            item.proteinChange,
        });
      } else if (isiOS) {
        window.webkit.messageHandlers.JSCallNative.postMessage(param);
      } else {
        window.android.JSCallNative(JSON.stringify(param));
      }
    },
    // 基因点击事件
    geneClick(item) {
      let param = {
        name: "wdJiedu",
        type: "0",
        gene: item.geneName,
        proteinChange: "",
        tabIndex: "2",
        fromSource: "snv",
        webId: "BGXQ-TXBBYJG",
        cancerTwo: item.cancerTwo,
        productCode: item.productCode,
      };
      if (this.$route.query.userAgent == "wxWeb") {
        wx.miniProgram.navigateTo({
          url:
            "/packageWebView/pages/gene-jiedu/gene-jiedu?gene=" + item.geneName,
        });
      } else if (isiOS) {
        window.webkit.messageHandlers.JSCallNative.postMessage(param);
      } else {
        window.android.JSCallNative(JSON.stringify(param));
      }
    },
    byClick(item) {
      let param = {
        name: "wdJiedu",
        type: "1",
        gene: item.geneName,
        proteinChange: "-" + item.proteinChange,
        tabIndex: "1",
        Jump: "1",
        fromSource: "snv",
        cancerTwo: item.cancerTwo,
        productCode: item.productCode,
      };
      if (isiOS) {
        window.webkit.messageHandlers.JSCallNative.postMessage(param);
      } else {
        window.android.JSCallNative(JSON.stringify(param));
      }
    },
    clearSearch() {
      this.list = this.searchData;
      this.finished = false;
      this.isEmpty = false;
    },
    searchFn() {
      /**搜索查询的方法 */
      if (this.searchVal) {
        this.finished = true;

        this.list = handleSearch(this.searchVal, this.mutationData);
        if (this.searchVal != "" && this.list.length === 0) {
          this.isEmpty = true;
        }
      }
    },

    uniqueArray(paylist) {
      var payArr = [paylist[0]];
      for (var i = 1; i < paylist.length; i++) {
        var payItem = paylist[i];
        var repat = false;
        for (var j = 0; j < payArr.length; j++) {
          if (payItem.uid == payArr[j].uid) {
            repat = true;
            break;
          }
        }
        if (!repat) {
          payArr.push(payItem);
        }
      }
      return payArr;
    },
    onLoad() {
      this.loading = false;

      // 异步更新数据

      // if (this.mutationData.length == 0) {
      //   this.finished = true;
      // } else {
      //   this.list = this.mutationData;
      //   this.searchData = this.mutationData;
      //   // if (this.mutationData.length < 10) {
      //   //   this.list = this.mutationData;
      //   //   this.searchData = this.mutationData;
      //   // } else {
      //   //   for (let i = 0; i < 5; i++) {
      //   //     this.list.push(this.mutationData[i]);
      //   //     this.searchData.push(this.mutationData[i]);
      //   //   }
      //   // }

      //   // 加载状态结束
      //   // 数据全部加载完成
      //   if (this.list.length >= this.mutationData.length) {
      //     this.finished = true;
      //   }
      // }
    },
  },
};
</script>
<style lang="less" scoped>
.show-loading {
  text-align: center;
  position: fixed;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.5);
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
}
/deep/.van-sticky {
  // background: url("../../assets/head-bg.png") no-repeat;
  background-size: 100% 100%;
  padding: 0 16px;
}
/deep/.van-sticky--fixed {
  .sticky {
    padding-bottom: 6px;
    // background: url("../../assets/head-bg.png") no-repeat;
    background-size: 100% 100%;
  }
}
.search {
  display: flex;
  align-items: center;
  // padding: 0 16px;
  /deep/.van-search {
    padding: 0;
    margin: 15px 0 24px;
  }
  div:last-child {
    width: 100%;
  }
  /deep/.van-search__content {
    height: 32px;
    height: 32px;
    background: #ffffff;
    box-shadow: 0px 6px 20px -2px rgba(52, 68, 132, 0.1);
    border-radius: 20px;
    .van-field__left-icon .van-icon,
    .van-field__right-icon .van-icon {
      color: #a4a9bf;
    }
    .van-field__control {
      font-size: 12px;
      font-family: @family;
      font-weight: 400;
      color: #a4a9bf;
    }
  }
}
.content {
  padding: 0 16px;
}
.null-box {
  padding-top: 120px;
}
.publicLess {
  /deep/.van-load {
    .van-loading__text {
      color: #4b84ff;
    }

    .van-loading__spinner--circular {
      color: #4b84ff;
    }
  }

  .publicLess-list {
    height: auto;
    padding-bottom: 10px;
    background: @background_color;
    // box-shadow: 0px 10px 20px -4px rgba(52, 68, 132, 0.16);
    border-radius: 10px;
    margin-bottom: 20px;

    .data-box {
      display: flex;
      padding-left: 24px;
      padding-top: 10px;

      .left {
        flex: 1;

        & > div {
          margin-bottom: 20px;
        }
      }

      .right {
        flex: 1;

        & > div {
          margin-bottom: 20px;
        }
      }

      h2 {
        font-size: 13px;
        font-family: @family;
        font-weight: 500;
        color: #2f354d;
        line-height: 18px;
      }

      p {
        font-size: 12px;
        font-family: @family;
        font-weight: 400;
        color: #a4a9bf;
        line-height: 17px;
        margin-bottom: 4px;
      }

      h3 {
        font-size: 13px;
        font-family: @family;
        font-weight: 500;
        color: #4b84ff;
        line-height: 18px;
      }

      h4 {
        font-size: 13px;
        font-family: @family;
        font-weight: 500;
        color: #27ca8d;
        line-height: 18px;
      }
    }

    .show-box {
      height: 20px;
      background: linear-gradient(
        360deg,
        rgba(58, 74, 134, 0) 0%,
        rgba(58, 74, 134, 0.06) 100%
      );
    }

    h1 {
      height: 70px;
      line-height: 70px;
      position: relative;
      font-size: 18px;
      font-family: @family;
      font-weight: 500;
      color: #4b84ff;
      text-indent: 24px;

      &::before {
        content: "";
        position: absolute;
        top: 50%;
        left: 0;
        margin-top: -7px;
        width: 3px;
        height: 14px;
        background: #4b84ff;
        border-radius: 0px 2px 2px 0px;
      }
    }
  }
}
</style>
